import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    profile: {
      username: null, // null means nobody signed in.
      firstName: null,
      lastName: null,
      city: null,
      bio: null,
    },
  },
  reducers: {
    setProfile: (state, action) => {
      state.profile.username = action.payload.username;
      state.profile.firstName = action.payload.firstName;
      state.profile.lastName = action.payload.lastName;
      state.profile.city = action.payload.city;
      state.profile.bio = action.payload.bio;
    },
    clearProfile: (state, _action) => {
      state.profile = {
        username: null,
        firstName: null,
        lastName: null,
        city: null,
        bio: null,
      };
    },
  },
});

export default userSlice;
